import { property as i } from "../beacon-property.d/index.js";
import { a as u, d as a, m as B } from "./lifecycle-decorators-Cg3csm0R.js";
var m = Object.defineProperty, c = Object.getOwnPropertyDescriptor, y = (p, e, r, t) => {
  for (var s = t > 1 ? void 0 : t ? c(e, r) : e, n = p.length - 1, o; n >= 0; n--)
    (o = p[n]) && (s = (t ? o(e, r, s) : o(s)) || s);
  return t && s && m(e, r, s), s;
};
function h(p) {
  let e = class extends p {
    constructor() {
      super(...arguments), this.opensBy = "";
    }
    get opensByElements() {
      if (this.opensBy) {
        const r = this.opensBy.split(" "), t = /* @__PURE__ */ new Map();
        return r.forEach((s) => {
          const n = this.getClosestHost();
          n ? Array.from(
            n.shadowRoot.querySelectorAll(s)
          ).forEach(
            (l) => t.set(l, !0)
          ) : Array.from(document.querySelectorAll(s)).forEach(
            (l) => t.set(l, !0)
          );
        }), t;
      }
    }
    /** @abstract */
    runOpensBySetup() {
    }
    /** @abstract */
    runOpensByClean() {
    }
    setupOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensBySetup();
    }
    cleanOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensByClean();
    }
    /**
     * Public-facing API method to refresh opens-by elements.
     * Some apps do not have control over the order of loading the trigger element vs. the popover.
     * This allows discovery of trigger elements after page load.
     */
    refreshOpensByElements() {
      this.cleanOpensByElements(), this.setupOpensByElements();
    }
  };
  return y([
    i({ attribute: "opens-by" })
  ], e.prototype, "opensBy", 2), y([
    u
  ], e.prototype, "setupOpensByElements", 1), y([
    a
  ], e.prototype, "cleanOpensByElements", 1), e = y([
    B("OpensBy")
  ], e), e;
}
export {
  h as O
};
